// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"MainLayout_MainLayout__59TNH","MainLayout__vertical":"MainLayout_MainLayout__vertical__2Fear"};